(function () {
  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function uniqueValues(values) {
    return Array.from(new Set(values.filter(Boolean)));
  }

  function getSelectedBundleValue(form, productId) {
    const selector = form.closest('product-form, .card-wrapper, .card, .product, .product__info-wrapper, body')
      ?.querySelector(`[data-product-id="${productId}"][data-scene-bundle-selector]`) || form.querySelector('[data-scene-bundle-selector]');

    if (!selector) return null;
    const checked = selector.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : 'sleeve';
  }

  function getSleeveVariantFromForm(form) {
    const variantInput = form.querySelector('input[name="id"]');
    return variantInput ? variantInput.value : null;
  }

  function getVariantOptionTokens(variantTitle) {
    return uniqueValues(String(variantTitle || '')
      .split('/')
      .map(function (part) { return normalize(part); }));
  }

  function findMatchingVariant(targetProductKey, sleeveVariantTitle) {
    const source = window.SceneBundles && window.SceneBundles.products && window.SceneBundles.products[targetProductKey];
    if (!source || !source.variants) return null;

    const wantedTokens = getVariantOptionTokens(sleeveVariantTitle);
    const variants = Object.values(source.variants);

    for (const variant of variants) {
      const haystack = uniqueValues([variant.title, variant.option1, variant.option2, variant.option3].map(normalize));
      const matched = wantedTokens.some(function (token) {
        return haystack.includes(token);
      });
      if (matched && variant.available) {
        return variant;
      }
    }

    return null;
  }

  function setError(form, message) {
    const wrapper = form.closest('.card-wrapper, .product__info-container, .product, .card, body');
    const error = wrapper ? wrapper.querySelector('[data-scene-bundle-error]') : null;
    if (!error) {
      if (message) alert(message);
      return;
    }

    if (message) {
      error.textContent = message;
      error.hidden = false;
    } else {
      error.textContent = '';
      error.hidden = true;
    }
  }

  async function addBundleItems(items) {
    const cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js';
    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || 'Could not add bundle to cart.');
    }

    return response.json();
  }

  function getProductJson(productId) {
    const node = document.getElementById('SceneBundleProductJson-' + productId);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function attachBundleInterceptors() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.sceneBundleBound === 'true') return;
      form.dataset.sceneBundleBound = 'true';

      form.addEventListener('submit', async function (event) {
        const productId = form.dataset.productId || form.getAttribute('data-product-id') || null;
        if (!productId) return;

        const bundleValue = getSelectedBundleValue(form, productId);
        if (!bundleValue || bundleValue === 'sleeve') return;

        event.preventDefault();
        setError(form, '');

        const sleeveVariantId = getSleeveVariantFromForm(form);
        const productJson = getProductJson(productId);
        if (!sleeveVariantId || !productJson || !productJson.variants) {
          setError(form, 'The bundle could not be built from this product card.');
          return;
        }

        const sleeveVariant = productJson.variants.find(function (variant) {
          return String(variant.id) === String(sleeveVariantId);
        });

        if (!sleeveVariant) {
          setError(form, 'Please choose a valid sleeve size first.');
          return;
        }

        const items = [{ id: sleeveVariant.id, quantity: 1 }];

        const boardMatch = findMatchingVariant('board', sleeveVariant.title);
        if (!boardMatch) {
          setError(form, 'No matching Scene Board was found for this size.');
          return;
        }
        items.push({ id: boardMatch.id, quantity: 1 });

        if (bundleValue === 'full') {
          const frameMatch = findMatchingVariant('frame', sleeveVariant.title);
          if (!frameMatch) {
            setError(form, 'No matching Scene Frame was found for this size.');
            return;
          }
          items.push({ id: frameMatch.id, quantity: 1 });
        }

        try {
          await addBundleItems(items);
          window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart';
        } catch (error) {
          setError(form, 'There was a problem adding this bundle to the cart.');
          console.error(error);
        }
      });
    });
  }

  function injectProductJson() {
    document.querySelectorAll('[data-scene-bundle-product-json]').forEach(function (node) {
      const productId = node.getAttribute('data-product-id');
      if (!productId || document.getElementById('SceneBundleProductJson-' + productId)) return;
      const script = document.createElement('script');
      script.type = 'application/json';
      script.id = 'SceneBundleProductJson-' + productId;
      script.textContent = node.textContent;
      document.body.appendChild(script);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    injectProductJson();
    attachBundleInterceptors();
    document.addEventListener('shopify:section:load', function () {
      injectProductJson();
      attachBundleInterceptors();
    });
  });
})();
